import { render, staticRenderFns } from "./appBoards.vue?vue&type=template&id=eea10862&scoped=true"
import script from "./appBoards.vue?vue&type=script&lang=js"
export * from "./appBoards.vue?vue&type=script&lang=js"
import style0 from "./appBoards.vue?vue&type=style&index=0&id=eea10862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eea10862",
  null
  
)

export default component.exports